import { api } from "@/utils/api";
import { Location } from "./Location";
import { sanitizePathParam } from "@/utils/sanitize";

export default class LocationRepository {
  async getLocationsByCountryOrganization(
    countryId: string | number,
    organizationId: string,
    name?: string,
    status?: string
  ): Promise<Location[]> {
    const cid = sanitizePathParam(countryId);
    const oid = sanitizePathParam(organizationId);
    const locations = await api.get(
      `locations/countries/${cid}/organizations/${oid}`,
      { params: { name, status } }
    );
    return locations.data;
  }

  async getLocationsByUser(userId: string): Promise<Location[]> {
    const uid = sanitizePathParam(userId);
    const locations = await api.get(`users/${uid}/locations`);
    return locations.data;
  }

  async postLocationsByCountryOrganization(
    countryId: string,
    organizationId: string,
    newLocations: Location[]
  ): Promise<boolean> {
    const cid = sanitizePathParam(countryId);
    const oid = sanitizePathParam(organizationId);
    const locations = await api.post(
      `locations/countries/${cid}/organizations/${oid}`,
      newLocations
    );
    return locations.data.success === 1;
  }

  async deleteLocation(locationId: number): Promise<boolean> {
    const lid = sanitizePathParam(locationId);
    const response = await api.delete(`/locations/${lid}`);
    return response.data;
  }

  async changeEnableLocation(
    organizationId: string,
    locationId: number,
    visible: boolean
  ): Promise<boolean> {
    const oid = sanitizePathParam(organizationId);
    const lid = sanitizePathParam(locationId);
    const response = await api.put(
      `locations/${lid}/organizations/${oid}/visible/${
        visible ? "false" : "true"
      }`
    );
    return response.data;
  }
}
